export const AUTH0_DOMAIN = process.env.REACT_APP_AUTH0_DOMAIN ?? "";
export const AUTH0_CLIENT_ID = process.env.REACT_APP_AUTH0_CLIENT_ID ?? "";
export const CONFIGCAT_KEY = process.env.REACT_APP_CONFIGCAT_KEY ?? "";
export const ONETWENTY_WATER_ENVIRONMENT =
  process.env.REACT_APP_ONETWENTY_WATER_ENVIRONMENT ?? "";
export const AWS_ACCOUNT_ID = process.env.REACT_APP_AWS_ACCOUNT_ID ?? "";
export const AWS_IDENTITY_POOL_ID =
  process.env.REACT_APP_AWS_IDENTITY_POOL_ID ?? "";
export const AWS_REGION = process.env.REACT_APP_AWS_REGION ?? "";
